import { render } from "./ExpirationDocument.vue?vue&type=template&id=e1d76d2c"
import script from "./ExpirationDocument.vue?vue&type=script&lang=js"
export * from "./ExpirationDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__